export default __webpack_public_path__ + "static/media/Camera.23d5913a.svg";